import request from "root/js/request";

export const getParsersCollectionsProductsById = async ({ collection_id, limit, offset }) => {
  const response = await request({
    url: `/parsers/collections/products/${collection_id}/`,
    method: "get",
    params: {
      limit,
      offset,
    },
  });
  return response.data;
};
